import styled from 'styled-components';

export const DialogOverlay = styled.div<{ zIndex?: number }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: ${({ zIndex }) => zIndex || '500'};
`;

export const DialogContent = styled.div<{
  minWidth?: string;
  maxWidth?: string;
  minHeight?: string;
  borderRadius?: string;
  zIndex?: number;
}>`
  position: fixed;
  background-color: #fff;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  z-index: ${({ zIndex }) => (zIndex ? zIndex + 10 : '510')};
  min-width: ${({ minWidth }) => minWidth};
  max-width: ${({ maxWidth }) => maxWidth};
  min-height: ${({ minHeight }) => minHeight};
  border-radius: ${({ borderRadius }) => borderRadius || '0.4rem'};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;
